import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import {
	Validator
} from 'vee-validate'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import csvHelper from '../importjsontocsv';
export default {
	name: 'Packingreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect
	},
	data: function() {
		return {
			limitExeed: false,
			recordLimit: 0,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// totalrows:0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			listProductivityPackingData: [],
			listWarehouseData: [],
			listPackingReportDataCsv: [],
			listuserData: [],
			csvFields: [],
			datenow: '',
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			username: '',
			transactionfromdate: '',
			transactiontodate: '',
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			user_type: '',
			isLoadingforxls: false,
			listMerchantData:[],
			MerchantList: [],
			merchantid: '',
			merchant: '',
			listMerchantIdData: [],
			item:{},
		    listMerchantData1:[],
		    merchantList:[],

		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('reports.productivityPackingReportFilename');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedWarehouse")!=='undefined' && localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData()
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getuserlist();
		  });
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantData()
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getuserlist();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.time();
		this.getRecordLimit()
	},
	methods: {
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                       this.item={
						   value:'',
						   text:''
					   };
						this.listMerchantData1=[{value:'',text: this.$t('common.selectMerchantPlaceHolder')}];
					    this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })
					}
				}, error => {
					console.error(error)
				})
		},
		reset(){
			this.item={}
		},
		onSelect(item){
			this.item=item
			this.merchant=item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getPackingreportDataForXls(3)
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		time() {
			var self = this
			this.datenow = moment().format()
			setInterval(self.time, 1000)
		},
		// jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
		//    var csvData = ''
		//    //Header
		//    if (this.title != null) {
		//      csvData += this.parseExtraData(this.title, '${data}\r\n')
		//    }
		//    //Fields
		//    for (let key in data[0]) {
		//      csvData += csvfield[key] + ','
		//    }
		//    csvData = csvData.slice(0, csvData.length - 1)
		//    csvData += '\r\n'
		//    //Data
		//    data.map(function(item) {
		//      for (let key in item) {

		//        // cast Numbers to string
		//        if (key == "CreatedDate") {
		//          var escapedCSV = moment(item[key]).format('DD-MM-YY HH:mm:ss') + '' // cast Numbers to string
		//        } else if (key == "transactiontodate") {
		//          var escapedCSV = moment(item[key]).format('DD-MM-YY HH:mm:ss') + '' // cast Numbers to string
		//        } else if (key == "transcationfromdate") {
		//          var escapedCSV = moment(item[key]).format('DD-MM-YY HH:mm:ss') + '' // cast Numbers to string
		//        } else {
		//          var escapedCSV = item[key] + '' // cast Numbers to string
		//        }
		//        if (escapedCSV.match(/[,"\n]/)) {
		//          escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
		//        }
		//        if (escapedCSV == 'null')
		//          csvData += ',';
		//        else {
		//          if (dateFilder.indexOf(key) != -1)
		//            csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
		//          else
		//            csvData += escapedCSV + ','
		//        }
		//      }
		//      csvData = csvData.slice(0, csvData.length - 1)
		//      csvData += '\r\n'
		//    })
		//    //Footer
		//    if (this.footer != null) {
		//      csvData += this.parseExtraData(this.footer, '${data}\r\n')
		//    }
		//    filename += moment().format('DD-MM-YY-HH-mm-ss') + '.csv';
		//    return this.export(csvData, filename, "application/csv");
		//    return csvData
		//  },
		 export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		getuserlist() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			//alert(this.user_type)
			if (this.user_type == 'system_user') {
				this.usertype = "system_user"
			}
			if (this.user_type == 'client_user') {
				this.usertype = "client_user"
			}
			if (this.user_type == 'warehouse_user') {
				this.usertype = "warehouse_user"
			}
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				utype: this.usertype
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'productivityReportUserList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listuserData = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {

		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.getMerchantData();
		// 		this.merchant='';
		// 		// this.warehouse = ''
		// 		this.listProductivityPackingData = [];

		// 		if (this.warehouseid) {
		// 			this.getuserlist();
		// 		}
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getPackingreportData();
		// 		}
		// 	}

		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getuserlist();

		// 			// console.log(this.warehouse);
		// 			// this.getPackingreportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getPackingreportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getPackingreportData();
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		//to get Stock list
		getPackingreportData(csvCheck = 0) {
			if(csvCheck!=1){
				this.download=true
				this.show=false;
			  }
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var packingto_date = '';
			var packingfr_date = '';
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			var dataFilter = {};
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageno = this.totalPage = 0;
				this.listProductivityPackingData = [];
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listProductivityPackingData = [];
				return false;
			}
			this.isLoading = true;
			if (this.transactionfromdate) {
				packingfr_date = this.dateFormat1(this.transactionfromdate)
			}

			if (this.transactiontodate == '') {
				packingto_date = '';
			} else {
				packingto_date = this.dateFormat2(this.transactiontodate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: packingfr_date,
				todate: packingto_date,
				user: this.username,
				csvData: csvCheck,
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				merchantid: this.merchant,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'productivityReportForPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (csvCheck ==1) {
							this.show = true;
							this.download = false;
							this.csvFields = {
								'createdby': this.$t('common.userName'),
								'packingdate': this.$t('productivityReport.transactionDate'),
								'totalsku': this.$t('reports.totalSKUChecked'),
								'totalboxes': this.$t('reports.totalBoxesPacked'),
								'totalaccepted': this.$t('reports.totalqtyaccepted'),
								'totalrejected': this.$t('reports.totalRejectedQty'),
								'merchantname': this.$t('common.merchantName')
							};
							var dateFilter = ['packingdate', 'transactiontodate', 'transactionfromdate'];
							var skipFilter = ['transcationdate'];
							this.listPackingReportDataCsv = result.data.data;
							// this.listPackingReportDataCsv1= [];
							// this.listPurchaseOrderDatacsv = []
							// this.jsonToCSV('Packingreport', this.listPackingReportDataCsv, this.csvFields, dateFilder, skipFilter);
							csvHelper.data.jsonToCSV(this.$t('reports.productivityPackingReportFilename'), this.listPackingReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
							// this.isLoading = false;
						} else {
							this.listProductivityPackingData = result.data.data;
							if (result.data.errorCode == -1) {
								this.resultCount = 0
							} else {
								this.totalRows = result.data.count;
								if (Number(this.totalRows) > Number(this.recordLimit)) {
									this.limitExeed = true
								}
								this.resultCount = result.data.count
								if (this.totalRows < 10) {
									this.totalPage = 1
								} else {
									this.totalPage = Math.ceil(this.totalRows / 10)
								}
							}
						}
						this.isLoading = false;
					},
					error => {
						console.error(error)
					})

		},

		// //set total num page counts
		// setPageCounts(total_rows){
		// 	if(total_rows > 0){
		// 		if(total_rows <= this.pageLimit){
		// 			this.totalPage = 1;
		// 		}else {
		// 			this.totalPage = Math.ceil(total_rows / this.pageLimit);
		// 		}
		// 	}else {
		// 		this.totalPage = 0;
		// 	}
		// },
		getPackingreportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var packingto_date = '';
			var packingfr_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';

			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageno = this.totalPage = 0;
				this.listProductivitydrData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehhouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageno = this.totalPage = 0;
				this.listProductivitydrData = [];
				return false;
			}
			if (this.transactionfromdate) {
				packingfr_date = this.dateFormat1(this.transactionfromdate)
			}

			if (this.transactiontodate == '') {
				packingto_date = '';
			} else {
				packingto_date = this.dateFormat2(this.transactiontodate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: packingfr_date,
				todate: packingto_date,
				user: this.username,
				csvData: csvCheck,
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				merchantid:this.merchant,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'productivityReportForPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls[this.$t('common.userName')] = 'createdby';
								this.csvFieldsForXls[this.$t('productivityReport.transactionDate')] = 'packingdate';
								this.csvFieldsForXls[this.$t('reports.totalSKUChecked')] = 'totalsku';
								this.csvFieldsForXls[this.$t('reports.totalBoxesPacked')] = 'totalboxes';
								this.csvFieldsForXls[this.$t('reports.totalqtyaccepted')] = 'totalaccepted';
								this.csvFieldsForXls[this.$t('reports.totalRejectedQty')] = 'totalrejected';
								this.csvFieldsForXls[this.$t('common.merchantName')] = 'merchantname';

								this.listReportDataforxls = result.data.data;
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}


						}


					},
					error => {
						console.error(error)
					})

		},
		//to reset search form
		resetForm() {
			this.show = false;
			this.download = true;
			this.username = '';
			this.transactionfromdate = '';
			this.transactiontodate = '';
			this.listProductivityPackingData = [];
			this.pageno = this.totalPage = 0;
			this.searchFlag = false;
			this.totalRows = 0;
			this.merchant='';
			this.item={}
			// this.warehouse = '';
			// this.getPackingreportData();
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		//to paginate  GRC List
		// getPaginationData(currentPage) {
		//   this.pageno = (currentPage - 1) * 10
		//   this.getPackingreportData()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getPackingreportData()
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/productivity report/productivitypackingreport/productivitypackingreport.component.js